import { render, staticRenderFns } from "./ModalLevel.vue?vue&type=template&id=4c0a7711"
import script from "./ModalLevel.vue?vue&type=script&lang=js"
export * from "./ModalLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports